function dateToString(dateTime) {
    if(dateTime == null) return "—";
    dateTime=new Date(dateTime);
    let dateString = `${("000" + dateTime.getFullYear()).slice(-4)}-${("0" + (dateTime.getMonth() + 1)).slice(-2)}-${("0" + dateTime.getDate()).slice(-2)}`;
    let timeString = `${("0" + dateTime.getHours()).slice(-2)}:${("0" + dateTime.getMinutes()).slice(-2)}:${("0" + dateTime.getSeconds()).slice(-2)}`;
    return (dateString + " " + timeString);
}

export default dateToString;